import { uniqId } from '@btime/helpers'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { DndHandler } from '../../../components/dnd/DndHandler'
import { useFields } from './_load/FieldsLoader'
import { useForm, useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useSaveFields } from './_requests/saveFields'
import FieldForm from './sections/fieldForm/FieldForm'
import FieldTypesList from './sections/fieldTypes/FieldTypesList'
import FieldsList from './sections/fields/FieldsList'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditFieldsForm = () => {
  const form = useForm()
  const { handleChange } = useFormState()

  return (
    <DndHandler>
      <Grid align="stretch">
        <Col width="15%" wrapOn="sm">
          <FieldTypesList />
        </Col>
        <Col>
          <Line vertical />
        </Col>

        <Col width="60%" wrapOn="sm">
          <FieldsList />
        </Col>

        <Col>
          <Line vertical />
        </Col>
        <Col width="25%" wrapOn="sm">
          <FieldForm />
        </Col>
      </Grid>
    </DndHandler>
  )
}

const Wrapper = () => {
  const fields = useFields().map(item => ({ ...item, reference: uniqId() }))
  const [onSubmit, { loading, error }] = useSaveFields()

  return (
    <Form onSubmit={!loading ? onSubmit : undefined} initialState={fields || []}>
      <EditFieldsForm />
      <Line />
      <SubmitBar loading={loading} />
    </Form>
  )
}

export default Wrapper
